import React from "react";
import { AppBar, Toolbar, Typography, Box, Button, Chip } from "@mui/material";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import apiClient from "../../services/apiClient";
import AdminErrorBoundary from "./AdminErrorBoundary";

const navItems = [
  { to: "/admin/prospection", label: "1. Trouver" },
  { to: "/admin/prospects", label: "2. Pipeline" },
  { to: "/admin/leads", label: "3. Leads" },
  { to: "/admin", label: "Dashboard", exact: true },
  { to: "/admin/settings", label: "Config" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await apiClient.adminLogout();
    } finally {
      navigate("/admin/login");
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}>
      <AppBar position="static" color="primary">
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ mr: 2 }}>DigiBuddy</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flex: 1 }}>
            {navItems.map((item) => {
              const active = item.exact
                ? location.pathname === item.to
                : location.pathname.startsWith(item.to);
              return (
                <Chip
                  key={item.to}
                  label={item.label}
                  component={Link}
                  to={item.to}
                  clickable
                  size="small"
                  variant={active ? "filled" : "outlined"}
                  aria-current={active ? "page" : undefined}
                  sx={{
                    color: active ? "primary.contrastText" : "#fff",
                    borderColor: "rgba(255,255,255,0.5)",
                    backgroundColor: active ? "rgba(255,255,255,0.25)" : "transparent",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                    fontWeight: active ? 700 : 400,
                    textDecoration: "none",
                  }}
                />
              );
            })}
          </Box>
          <Button color="inherit" size="small" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ maxWidth: 1400, mx: "auto", py: 3, px: 2 }}>
        <AdminErrorBoundary>
          <Outlet />
        </AdminErrorBoundary>
      </Box>
    </Box>
  );
}
